'use client';

import React, { useEffect, useState } from 'react';
import { classnames } from 'helpers/utils/classnames';
import { tastics } from 'frontastic/tastics';
import Cell from './components/cell';
import Grid from './components/grid';
import TasticWrapper from './components/tastic-wrapper';
import { RendererProps } from './types';
import { highlight } from './utils/highlight';

const Renderer = ({
  data: pageData,
  params,
  searchParams,
  currentHighlight,
  gridClassName = '',
  wrapperClassName = '',
  categories = [],
  projectConfig,
}: RendererProps) => {
  const { page, data } = pageData;

  const sections = [page.sections.head, page.sections.main, page.sections.footer];

  const sectionsClassNames = {
    head: '',
    main: 'grow body-section',
    footer: '',
  } as Record<string, string>;

  const [loading, setLoading] = useState<boolean>(false);
  useEffect(() => {
    const handleScroll = () => {
      setLoading(true);
    }

    if (typeof window !== "undefined" && !loading) {
      window.addEventListener('scroll', handleScroll, { once: true });
    }

  }, [loading]);

  return (
    <div className="flex min-h-screen flex-col items-stretch justify-start">
      {sections.filter(Boolean).map((section) => (
        <Grid
          key={section.sectionId}
          gridClassName={gridClassName}
          wrapperClassName={classnames(
            'relative w-full',
            wrapperClassName,
            highlight(currentHighlight === section.sectionId),
            sectionsClassNames[section.sectionId],
          )}
        >
          {section.layoutElements?.map((layoutElement, eid) => (
            <Cell
              key={layoutElement.layoutElementId}
              configuration={layoutElement.configuration}
              isHighlighted={currentHighlight === layoutElement.layoutElementId}
            >
              {layoutElement.tastics.map((tastic, index) => (
                <TasticWrapper
                  key={tastic.tasticId}
                  data={tastic}
                  params={params}
                  searchParams={searchParams}
                  dataSources={data.dataSources}
                  tastics={tastics}
                  isHighlighted={currentHighlight === tastic.tasticId}
                  categories={categories}
                  projectConfig={projectConfig}
                  isDisplayed={section.sectionId !== 'main' || eid !== 0 || layoutElement.tastics.every(e => e.tasticType !== 'padi-product/details') || index < 2 || loading}
                />
              ))}
            </Cell>
          ))}
        </Grid>
      ))}
    </div>
  );
};

export default Renderer;
